<template>
    <div class="allCourse fl" @mouseenter="leftShow()" @mouseleave="leftHide()">
        <h3 v-if="leftIsShow == 0"><i class="iconfont">&#xe659;</i>&nbsp;&nbsp;&nbsp;课程导航</h3>
        <h3 v-else><i class="iconfont">&#xe659;</i>&nbsp;&nbsp;&nbsp;课程导航</h3>
        <div class="homeLeftNav" v-if="show">
        <ul class="homeLeftNav-list">
            <li class="category-item senior-school-active" 
                :class="{active:gradeInfo.isActive,activeBorderBottomNone:gradeInfo.borderBottomNone}"
                v-for="gradeInfo in gradeList"
                :key="gradeInfo.gradeId" @click="gotoCourseList(gradeInfo.gradeId)">
                <div >
                    
                        <h4>{{gradeInfo.gradeTitle}}</h4>
                    
                </div>
                <div class="border-bottom" v-show="gradeInfo.borderBottomNone"></div>
                
            </li>
        </ul>
      </div>
    </div>
</template>
<script>
export default {
    props:{
      leftIsShow:{
        type:Number,
        default:1
      }
    },
    data(){
		return{
            gradeList:[
                {
                    gradeId: '0',
                    isActive: false,
                    gradeTitle: '预备级',
                    borderBottomNone:true
                },
                {
                    gradeId: '1',
                    isActive: false,
                    gradeTitle: '一级',
                    borderBottomNone:true
                },
                {
                    gradeId: '2',
                    isActive: false,
                    gradeTitle: '二级',
                    borderBottomNone:true
                },
                {
                    gradeId: '3',
                    isActive: false,
                    gradeTitle: '三级',
                    borderBottomNone:true
                },
                {
                    gradeId: '4',
                    isActive: false,
                    gradeTitle: '四级',
                    borderBottomNone:true
                },
                {
                    gradeId: '5',
                    isActive: false,
                    gradeTitle: '五级',
                    borderBottomNone:true
                },
                {
                    gradeId: '6',
                    isActive: false,
                    gradeTitle: '六级',
                    borderBottomNone:false
                }
            ],
            show:false
        }
    },
    methods:{
        gotoCourseList(juniorId){
            this.$router.push({ name: 'courseList', params: {juniorId:juniorId,searchType:1002}});
        },
        leftHide(){
            this.show = false
        },
        leftShow(){
            if(this.leftIsShow==1){
                this.show = false;
            }else{
                this.show = true
            }
        },
    }
}
</script>
<style type="text/css" scoped="scoped">
    *{
        box-sizing: border-box;
    }
    #header .header-menu .allCourse{
        position: relative;
    }
    #header .header-menu .allCourse h3{
        width: 240px;
        background-color: #f49d40;
        color: #fff;
        padding:12px 23px 12px 20px;
        cursor: pointer;
        font-size: 18px;
    }
    #header .header-menu .allCourse h3 i.iconfont{
        font-size: 21px;
    }

    .homeLeftNav{
        position: relative;
    }

    .homeLeftNav .homeLeftNav-list{
        width: 240px;
        /*background-color: rgba(0,0,0,0.5);*/
        /*background-color: rgba(255,255,255,1);*/
        /*background-color: rgba(236, 236, 236, 0.85);*/
        background-color: rgba(255,255,255,0.7);
        position: absolute;
        z-index: 10;
        overflow: hidden;
    }
    .homeLeftNav .homeLeftNav-list .category-item{
        border:2px solid rgba(0,0,0,0);
        position: relative;
    }
    .homeLeftNav .homeLeftNav-list .category-item >div{
        cursor: pointer;
        padding:12px 20px 8px;
    }
    .homeLeftNav .homeLeftNav-list .category-item .border-bottom{
        border-bottom: 1px solid #999;
        position: absolute;
        bottom: 0;
        width: 100%;
    }
   
</style>